import {white} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';

const loginstyles = {
    container: {
        backgroundColor: 'inherit',
        color: white,
        border: 0,
        boxShadow:0
    },
    content: {
        padding: '5px 10px',
        marginLeft: 90,
        height: 80,
        backgroundColor: 'inherit',
        color: white
      },
      text: {
        display: 'inline-flex',
        verticalAlign: 'middle',
        fontWeight: typography.fontWeightMedium,
        color: white,
        paddingTop: 25
      },
      iconSpan: {
        float: 'left',
        height: 90,
        width: 90,
        textAlign: 'center',
        backgroundColor: 'inherit',
        color: white
      },
      icon: {
        height: 64,
        width: 64,
        marginTop: 20,
        maxWidth: '100%',
        backgroundColor: white

      }
};

export default loginstyles;



// WEBPACK FOOTER //
// ./src/components/login/styles/LoginFormBoxStyles.js